// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-n_hx","advertDetailParameterList__header":"c-n_hy","advertDetailParameterList__list":"c-n_hz"};